export enum PAGES {
    FORM,
    CODE,
    SUCCESS,
    ERROR,
}

export enum COMPANIES {
    DODO = "dodo",
}
